import React, { useState } from "react";
import { useAuth } from "../../util/auth";
import { TEAM_MAX_SEATS } from "../../util/prices";
import { Link } from '../../util/router';
import SideNav from "./SideNav";
import StateFarmCheckModal from "./StateFarmCheckModal";
import PersonCard from "./PersonCard";
import InviteLinkModal from "./InviteLinkModal";
import { HomeIcon, LinkIcon, UserGroupIcon } from '@heroicons/react/24/solid';

function TeamsSection(props) {
  const auth = useAuth();
  const [inviteLinkModalOpen, setInviteLinkModalOpen] = useState(false);

  // Get team members directly from user document
  const teamMembers = auth.user?.teamMembers || [];

  // Every owner gets exactly ten seats, whichever subscription they hold and
  // whatever quantity they bought (decision, Ben, 2026-09-22). A seat add-on
  // product comes later, on the new stack. Checkout is pinned to quantity 1,
  // so stripeQuantity is vestigial and no longer multiplies this.
  const availableSeats = TEAM_MAX_SEATS - teamMembers.length;

  return (
    <>
      <div className="container">
        {/* Header */}
        <div className="pl-4 flex flex-row items-center justify-between mb-4">
          <div className="flex flex-row items-center">
            <Link to="/dashboard/dashboard">
              <HomeIcon className="text-gray-400 h-6" />
            </Link>
            <div className="pl-4">
              <p className="text-lg font-semibold">Team Members</p>
              <p className="text-sm text-gray-400">
                {teamMembers.length} Member{teamMembers.length !== 1 ? 's' : ''} | {availableSeats} seat{availableSeats !== 1 ? 's' : ''} available
              </p>
            </div>
          </div>

          {/* Invite Button */}
          <button
            onClick={() => setInviteLinkModalOpen(true)}
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700"
          >
            <LinkIcon className="h-5 w-5" />
            Invite Team Members
          </button>
        </div>

        {/* Team Members Grid */}
        <div className="flex flex-wrap justify-center lg:justify-start gap-4 p-4">
          {teamMembers.length > 0 ? (
            teamMembers.map((memberUid) => (
              <PersonCard
                key={memberUid}
                uid={memberUid}
                teamMembers={teamMembers}
                selfUid={auth.user.uid}
                isOwner={true}
              />
            ))
          ) : (
            /* Empty State */
            <div className="w-full flex flex-col items-center justify-center py-12 text-center">
              <UserGroupIcon className="h-16 w-16 text-gray-300 mb-4" />
              <h3 className="text-xl font-semibold text-gray-700 mb-2">No Team Members Yet</h3>
              <p className="text-gray-500 mb-6 max-w-md">
                Invite team members to give them access to your training resources.
                Share a link via text, email, or in person.
              </p>
              <button
                onClick={() => setInviteLinkModalOpen(true)}
                className="flex items-center gap-2 bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700"
              >
                <LinkIcon className="h-5 w-5" />
                Invite Your First Team Member
              </button>
            </div>
          )}
        </div>
      </div>

      <SideNav current="teams" />
      <StateFarmCheckModal onDone={() => null} />

      <InviteLinkModal
        isOpen={inviteLinkModalOpen}
        onClose={() => setInviteLinkModalOpen(false)}
      />
    </>
  );
}

export default TeamsSection;
